import { render, staticRenderFns } from "./activitybar.vue?vue&type=template&id=2ce29e87"
import script from "./activitybar.js?vue&type=script&lang=js&external"
export * from "./activitybar.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports